/* eslint-env browser */
/* eslint-disable complexity */
import { inject, observer } from 'mobx-react';
import * as React from 'react';

import { ILocalization, withLocalization } from 'bernie-l10n';

import { SearchResultsStore } from 'stores/search-results-store';

import { SortAndFilterModel } from 'components/common/search-form/fields/filter-types';

import { UitkSpacing } from 'uitk-react-spacing';

import { MapToggle } from 'components/search/map/map-toggle';
import { SearchForm } from 'components/common/search-form';

export interface SidebarProps {
  searchResults: SearchResultsStore;
  isActive: boolean;
  l10n: ILocalization;
  routeStore?: any;
  withFilters?: boolean;
}

@withLocalization
@inject('searchResults', 'routeStore')
@observer
export class Sidebar extends React.Component<SidebarProps> {
  public static defaultProps = {
    isActive: false,
    l10n: null,
    withFilters: true,
  };

  public scrollToTop() {
    window.scrollTo(0, 0);
  }

  // eslint-disable-next-line complexity
  public render() {
    const { searchResults, isActive, withFilters } = this.props;
    const searchCriteria = searchResults && searchResults.searchCriteria;
    const regionId = searchCriteria && searchCriteria.regionId;
    const latLong = searchCriteria && searchCriteria.latLong;
    const group = searchCriteria && searchCriteria.group;
    const { l10n } = this.props;
    const { formatText } = l10n;

    const searchResultsCriteria = searchResults && searchResults.searchCriteria;
    const sortAndFilterOptions: SortAndFilterModel = searchResults && searchResults.sortAndFilter && searchResults.sortAndFilter.options;
    const sortAndFilterDefaults: any = searchResults && searchResults.sortAndFilter && searchResults.sortAndFilter.defaults;
    const filters = searchResults && searchResults.searchAndFilterDisplayOptions && searchResults.searchAndFilterDisplayOptions.filters;
    const displayFields = filters && filters.displayFields;
    const ignoreFields = filters && filters.ignoreFields;
    const mapImage = searchResults && searchResults.map && searchResults.map.staticMapSrc;
    const pwaMapOverlay: boolean = Boolean(
      this.props.routeStore &&
        this.props.routeStore.queryParams &&
        this.props.routeStore.queryParams.pwaOverlay &&
        this.props.routeStore.queryParams.pwaOverlay === 'map'
    );
    const shouldShowSidebar = regionId || latLong || group || sortAndFilterOptions;
    const displayFieldsNoSort = displayFields && displayFields.filter(item => item !== 'sort');

    return (
      <>
        {shouldShowSidebar && (
          <section data-stid="desktop-sidebar">
            {searchResults && searchResults.map && (
              <div>
                <MapToggle isActive={isActive} mapImage={mapImage} />
              </div>
            )}
            {withFilters && (
              <>
                <h2 className="is-visually-hidden">{formatText('hotels.searchResults.filtersDialog.title')}</h2>
                {!pwaMapOverlay && (
                  <UitkSpacing padding={{ blockend: 'twelve' }}>
                    <SearchForm
                      model={searchResultsCriteria}
                      sortAndFilterOptions={sortAndFilterOptions}
                      sortAndFilterDefaults={sortAndFilterDefaults}
                      provideDefaultSubmitButton={false}
                      displayFields={displayFieldsNoSort}
                      ignoreFields={ignoreFields}
                      autoSubmit={true}
                      searchable={true}
                      afterSubmit={this.scrollToTop}
                    />
                  </UitkSpacing>
                )}
              </>
            )}
          </section>
        )}
      </>
    );
  }
}
